module.exports = __webpack_public_path__ + "static/img/94-1.fa39899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/94-1.jpg
// module id = F/Fd
// module chunks = 0